import React from 'react';
import { Modal, Button } from "react-bootstrap";
import SlbButton from './button';


const _props = {
    show: false,
    setShow: () => { },
    title: '',
    children: <></>,
    handleOk:() => {},
    handleCancel: () => {}
}

function ConformationPopup(props = _props) {
    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={props.show}
            dialogClassName="modalWidth"
            className='rc_popup'
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.children}
            </Modal.Body>
            <Modal.Footer>
                <SlbButton type='button' className='cancel_btn' onClick={props.handleCancel}>{props.CancelButtonlabel}</SlbButton>
                <SlbButton type='button' onClick={props.handleOk}>{props.SaveButtonlabel}</SlbButton>
            </Modal.Footer>
        </Modal>
    );
}
export default ConformationPopup; 